export class HTMLContent {
  constructor({ component, content, ...props }) {
    this.component = component
    this.content = content
    this.props = { ...props }
  }

  extend(props) {
    this.props = { ...this.props, ...props }
  }

  reduce() {
    return {
      component: this.component,
      content: this.content,
      props: this.props
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/classes/HTMLContent.js